import { render, staticRenderFns } from "./view-agent.vue?vue&type=template&id=b1c7437e&scoped=true&"
import script from "./view-agent.vue?vue&type=script&lang=js&"
export * from "./view-agent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c7437e",
  null
  
)

export default component.exports